export default __webpack_public_path__ + "static/internet-music-e0cbf847d3de80f0c360f377c733edc0.png";